import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'qumra-input-text',
  styleUrl: 'qumra-input-text.css',
  shadow: true,
})
export class QumraInputText {
  @Prop() keyVal: string;
  @Prop() label: string;
  @Prop() value: any;
  @Prop() icon: any;
  @Prop() handleChange: Function;

  render() {
    return (
      <div class="qumra-input">
        <div class=" qumra-input-label">{this.label}</div>
        <div key={this.keyVal} class="qumra-input-container">
        {this.icon ? <span class="icon-container">
          <img src={this.icon} class="qumra-input-icon" loading="lazy"/>
         </span> : <svg width={"18"} height={"18"} xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
  <path d="M9.5,23h1.5v1h-1.5c-.821,0-1.544-.403-2-1.015-.456,.613-1.179,1.015-2,1.015h-1.5v-1h1.5c.827,0,1.5-.673,1.5-1.5V2.5c0-.827-.673-1.5-1.5-1.5h-1.5V0h1.5c.821,0,1.544,.403,2,1.015,.456-.613,1.179-1.015,2-1.015h1.5V1h-1.5c-.827,0-1.5,.673-1.5,1.5V21.5c0,.827,.673,1.5,1.5,1.5ZM21.5,3H10v1h11.5c.827,0,1.5,.673,1.5,1.5v14.5H10v1h14V5.5c0-1.378-1.121-2.5-2.5-2.5ZM4.5,20H1V5.5c0-.827,.673-1.5,1.5-1.5h2.5v-1H2.5c-1.378,0-2.5,1.122-2.5,2.5v15.5H4.5v-1Zm12.5-3V8h4v-1H12v1h4v9h1Z"/>
</svg>}
          <input
            onKeyUp={event => this.handleChange(this.keyVal, (event.target as HTMLInputElement).value)}
            value={this.value}
            class="qumra-input-text"
            placeholder={this.label}
            type="text"
          />
        </div>
      </div>
    );
  }
}
